// Generated by extract-enums.sh — do not edit manually

export enum ChargeResultStatusEnum {
  SUCCEEDED = "succeeded",

  ACTION_REQUIRED = "action_required",

  STRIPE_SDK_REQUIRED = "stripe_sdk_required"
}

export enum ConnectionStatusEnum {
  ACTIVE = "active",

  SUSPENDED = "suspended"
}

export enum ContractActionBlockerEnum {
  CONTRACT_NOT_SIGNED = "contract_not_signed",
  CONTRACT_CANCELLED = "contract_cancelled",
  CONTRACT_ENDED = "contract_ended",

  NOT_ACTING_PARTY = "not_acting_party",

  CONNECTION_SUSPENDED = "connection_suspended",

  PARTNER_NOT_SIGNED = "partner_not_signed"
}

export enum ContractStatusEnum {
  DRAFT = "draft",

  SIGNED = "signed",

  EXPIRED = "expired",

  CANCELLED = "cancelled"
}

export enum ContractTypeEnum {
  COTREATMENT = "cotreatment",

  REFERRAL_FREE = "referral_free",
  REFERRAL_PAID = "referral_paid"
}

export enum EducationEnum {
  DDS = "dds",

  DMD = "dmd",

  DDS_PHD = "dds_phd",

  DMD_PHD = "dmd_phd",

  MS = "ms",

  MSD = "msd"
}

export enum InvoiceStatusEnum {
  DRAFT = "draft",

  PENDING = "pending",

  PAID = "paid",

  FAILED = "failed",

  CANCELLED = "cancelled",

  TAX_FAILED = "tax_failed"
}

export enum LicenceStateEnum {
  ALABAMA = "alabama",

  ALASKA = "alaska",

  ARIZONA = "arizona",

  ARKANSAS = "arkansas",

  CALIFORNIA = "california",

  COLORADO = "colorado",

  CONNECTICUT = "connecticut",

  DELAWARE = "delaware",

  FLORIDA = "florida",

  GEORGIA = "georgia",

  HAWAII = "hawaii",

  IDAHO = "idaho",

  ILLINOIS = "illinois",

  INDIANA = "indiana",

  IOWA = "iowa",

  KANSAS = "kansas",

  KENTUCKY = "kentucky",

  LOUISIANA = "louisiana",

  MAINE = "maine",

  MARYLAND = "maryland",

  MASSACHUSETTS = "massachusetts",

  MICHIGAN = "michigan",

  MINNESOTA = "minnesota",

  MISSISSIPPI = "mississippi",

  MISSOURI = "missouri",

  MONTANA = "montana",

  NEBRASKA = "nebraska",

  NEVADA = "nevada",

  NEW_HAMPSHIRE = "new_hampshire",
  NEW_JERSEY = "new_jersey",
  NEW_MEXICO = "new_mexico",
  NEW_YORK = "new_york",

  NORTH_CAROLINA = "north_carolina",
  NORTH_DAKOTA = "north_dakota",

  OHIO = "ohio",

  OKLAHOMA = "oklahoma",

  OREGON = "oregon",

  PENNSYLVANIA = "pennsylvania",

  RHODE_ISLAND = "rhode_island",

  SOUTH_CAROLINA = "south_carolina",
  SOUTH_DAKOTA = "south_dakota",

  TENNESSEE = "tennessee",

  TEXAS = "texas",

  UTAH = "utah",

  VERMONT = "vermont",

  VIRGINIA = "virginia",

  WASHINGTON = "washington",

  WEST_VIRGINIA = "west_virginia",

  WISCONSIN = "wisconsin",

  WYOMING = "wyoming",

  DISTRICT_OF_COLUMBIA = "district_of_columbia",

  AMERICAN_SAMOA = "american_samoa",

  GUAM = "guam",

  NORTHERN_MARIANA_ISLANDS = "northern_mariana_islands",

  PUERTO_RICO = "puerto_rico",

  US_VIRGIN_ISLANDS = "us_virgin_islands",

  ALBERTA = "alberta",

  BRITISH_COLUMBIA = "british_columbia",

  MANITOBA = "manitoba",

  NEW_BRUNSWICK = "new_brunswick",

  NEWFOUNDLAND_AND_LABRADOR = "newfoundland_and_labrador",

  NORTHWEST_TERRITORIES = "northwest_territories",

  NOVA_SCOTIA = "nova_scotia",

  NUNAVUT = "nunavut",

  ONTARIO = "ontario",

  PRINCE_EDWARD_ISLAND = "prince_edward_island",

  QUEBEC = "quebec",

  SASKATCHEWAN = "saskatchewan",

  YUKON = "yukon"
}

export enum MsoTypeEnum {
  DSO = "dso",

  OSO = "oso"
}

export enum PracticeStaffStatusEnum {
  ACTIVE = "active",

  INACTIVE = "inactive"
}

export enum PreferredCommunicationChannelEnum {
  EMAIL = "email",

  PHONE = "phone"
}

export enum RoleEnum {
  INITIATOR = "initiator",

  PARTNER = "partner"
}

export enum SignMethodEnum {
  MANUAL = "manual",

  AUTOMATIC = "automatic",

  DOCUSIGN = "docusign"
}

export enum SystemEnum {
  DM = "dm",

  OD = "od",

  C9 = "c9",

  DOCUSIGN = "docusign",

  ITERO = "itero"
}

export enum TaxonomyCodeEnum {
  VALUE122300000_X = "122300000X",

  VALUE1223_G0001_X = "1223G0001X",
  VALUE1223_D0001_X = "1223D0001X",
  VALUE1223_E0200_X = "1223E0200X",
  VALUE1223_X0400_X = "1223X0400X",
  VALUE1223_P0221_X = "1223P0221X",
  VALUE1223_P0300_X = "1223P0300X",
  VALUE1223_P0700_X = "1223P0700X",
  VALUE1223_P0106_X = "1223P0106X",
  VALUE1223_X0008_X = "1223X0008X",
  VALUE1223_S0112_X = "1223S0112X"
}

export enum TypePricingEnum {
  PER_FILE = "per_file",
  PER_PACK = "per_pack"
}
